import React from 'react';
import Stack, { StackProps } from 'atoms/Layout/Stack/Stack';
import { ImageCardProps } from 'molecules/ImageCard/ImageCard';
import HeadingAndSupportingText, {
  HeadingAndSupportingTextProps,
} from 'molecules/HeadingAndSupportingText/HeadingAndSupportingText';
import ImageCardList from 'molecules/ImageCardList/ImageCardList';

interface HeadingAndImageCardListProps {
  headingAndSupportingText: HeadingAndSupportingTextProps;
  imageCards: ImageCardProps[];
  totalColumns?: number;
  totalColumnsLg?: number;
  totalColumnsSm?: number;
  justify?: StackProps['justify'];
  align?: StackProps['align'];
}

const HeadingAndImageCardList = ({
  headingAndSupportingText,
  imageCards,
  totalColumns,
  totalColumnsLg,
  totalColumnsSm,
  justify,
  align,
}: HeadingAndImageCardListProps): JSX.Element => {
  return (
    <Stack
      direction='column'
      gap='spacing-5xl'
      gapSm='spacing-4xl'
      justify={justify}
      align={align}
    >
      <HeadingAndSupportingText {...headingAndSupportingText} />
      <ImageCardList
        imageCards={imageCards}
        totalColumns={totalColumns}
        totalColumnsLg={totalColumnsLg}
        totalColumnsSm={totalColumnsSm}
      />
    </Stack>
  );
};

export default HeadingAndImageCardList;
